import { render, staticRenderFns } from "./CreateTicketNote.vue?vue&type=template&id=35386ed4&scoped=true&"
import script from "./CreateTicketNote.vue?vue&type=script&lang=js&"
export * from "./CreateTicketNote.vue?vue&type=script&lang=js&"
import style0 from "./CreateTicketNote.vue?vue&type=style&index=0&id=35386ed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35386ed4",
  null
  
)

export default component.exports